import React, { PureComponent } from 'react';
import moment from 'moment';
import first from 'lodash/first';
import InformationSection from '../../../../components/InformationSection';

class NextStream extends PureComponent {
	render() {
		const { locale, nextStream } = this.props;
		let date = null;
		if (nextStream) {
			const language = first(navigator.language.split('_'));
			moment.locale(language, {
				months: locale['calendar.months'].split('_'),
				weekdays: locale['calendar.days'].split('_'),
				calendar: {
					sameDay: `[${locale['calendar.sameDay']}] HH:mm`,
					nextDay: `[${locale['calendar.nextDay']}] HH:mm`,
					nextWeek: 'dddd HH:mm',
					lastDay: `[${locale['calendar.lastDay']}] HH:mm`,
					lastWeek: 'dddd HH:mm',
					sameElse: 'dddd D MMM HH:mm',
				},
			});
			date = moment(nextStream.airdate).calendar();
		}
		return (
			<InformationSection>
				<InformationSection.Label>{locale['next.stream']}</InformationSection.Label>
				{date ? (
					<InformationSection.Value>{date}</InformationSection.Value>
				) : (
					<InformationSection.Value>{locale['not.known']}</InformationSection.Value>
				)}
			</InformationSection>
		);
	}
}

NextStream.propTypes = {};

NextStream.defaultProps = {};

export default NextStream;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/nextStream/NextStream.component.js